<template>
  <div>
    <el-dialog
      :before-close="handleClose"
      :title="'发放记录---' + row.name"
      :visible.sync="Allotvisible"
      append-to-body
      width="70%"
    >
      <div>
        <el-form :inline="true">
          <el-form-item label="用户昵称">
            <el-input
              v-model="Allot_Form.name"
              class="cus_width"
              clearable
              placeholder="用户昵称"
              @keyup.enter.native="getsch"
            ></el-input>
          </el-form-item>
          <el-form-item>
            <el-button type="success" @click="getsch">搜索</el-button>
          </el-form-item>
        </el-form>
        <el-table
          :data="Allot_list"
          border
          stripe
          style="width: 100%"
          tooltip-effect="dark"
        >
          <el-table-column align="center" label="用户昵称" prop="nickName">
          </el-table-column>
          <el-table-column
            align="center"
            label="联系方式"
            prop="phone"
          ></el-table-column>
          <el-table-column align="center" label="发放方式" prop="releaseMode">
            <template slot-scope="scope">
              <el-tag v-if="scope.row.releaseMode == 1" type="success"
                >自动发放</el-tag
              >
              <el-tag v-if="scope.row.releaseMode == 2" type="warning"
                >用户领取</el-tag
              >
            </template>
          </el-table-column>
          <el-table-column
            align="center"
            label="有效期"
            prop="createTime"
            width="360px"
          >
            <template slot-scope="scope">
              {{ scope.row.startTime }} 至 {{ scope.row.endTime }}
            </template>
          </el-table-column>
        </el-table>
        <el-pagination
          :current-page="Allot_Form.pageNo"
          :page-size="Allot_Form.pageSize"
          :page-sizes="[10, 20, 50, 100]"
          :total="Allot_total"
          layout="total, sizes, prev, pager, next, jumper"
          @size-change="handleDuSizeChange"
          @current-change="handleDuCurrentChange"
        >
        </el-pagination>
      </div>
    </el-dialog>
  </div>
</template>
<script>
export default {
  components: {},
  data() {
    return {
      row: {},
      Allot_list: [],
      Allotvisible: false,
      Allot_total: 0,
      Allot_Form: {
        pageNo: 1,
        pageSize: 10,
        couponsId: "",
        name: "",
      },
    };
  },
  created() {},
  methods: {
    getStash() {
      this.$axios
        .post("/admin/sysCouponSheet/grantIssueCoupon", this.Allot_Form)
        .then((res) => {
          this.Allot_list = res.data.records;
          this.Allot_total = res.data.total;
        });
    },
    getsch() {
      this.Allot_Form.pageNo = 1;
      this.getStash();
    },
    handleDuCurrentChange(val) {
      this.Allot_Form.pageNo = val;
      this.getStash();
    },
    handleDuSizeChange(val) {
      this.Allot_Form.pageSize = val;
      this.getStash();
    },

    init(row) {
      this.row = row;
      this.Allot_Form = {
        pageNo: 1,
        pageSize: 10,
        couponsId: row.id,
      };
      this.getStash();
      this.Allotvisible = true;
    },
    handleClose() {
      this.Allotvisible = false;
    },
  },
};
</script>

<style scoped>
.el-button {
  padding: 0 10px;
  height: 35px;
  line-height: 35px;
  font-size: 15px;
  margin-right: 10px;
}

.cus_area {
  margin: 10px;
}
</style>
